<template>
<w-tool-tabs class="tab-button" v-model="activeTab">
  <div slot="tool">
    <!-- <span v-if="activeTab === 'WDeviceList'">
      <el-button icon="fas fa-file-excel" size="small" @click="$refs.deviceList.$options.methods.exportExcel">엑셀출력</el-button>
      <w-header-search-button @click="$refs.deviceList.showSearchTool = !$refs.deviceList.showSearchTool"/>
    </span> -->
  </div>
  <el-tab-pane label="호스트 클러스터" name="WTopologymapHostClusterConfigTable">
    <w-topologymap-host-cluster-config-table :active="active && activeTab === 'WTopologymapHostClusterConfigTable'"></w-topologymap-host-cluster-config-table>
  </el-tab-pane>
  <el-tab-pane label="호스트" name="WTopologymapHostConfigTable">
    <w-topologymap-host-config-table :active="active && activeTab === 'WTopologymapHostConfigTable'"></w-topologymap-host-config-table>
  </el-tab-pane>
  <el-tab-pane label="VM" name="WTopologymapVmConfigTable">
    <w-topologymap-vm-config-table :active="active && activeTab === 'WTopologymapVmConfigTable'"></w-topologymap-vm-config-table>
  </el-tab-pane>
  <el-tab-pane label="스토리지 클러스터" name="WTopologymapStorageClusterConfigTable">
    <w-topologymap-storage-cluster-config-table :active="active && activeTab === 'WTopologymapStorageClusterConfigTable'"></w-topologymap-storage-cluster-config-table>
  </el-tab-pane>
  <el-tab-pane label="스토리지" name="WTopologymapStorageConfigTable">
    <w-topologymap-storage-config-table :active="active && activeTab === 'WTopologymapStorageConfigTable'"></w-topologymap-storage-config-table>
  </el-tab-pane>
</w-tool-tabs>
</template>

<script>

import WTopologymapHostClusterConfigTable from '@/views/topologymap/components/perfoper/config/components/virtual/TopologymapHostClusterConfigTable';
import WTopologymapHostConfigTable from '@/views/topologymap/components/perfoper/config/components/virtual/TopologymapHostConfigTable';
import WTopologymapVmConfigTable from '@/views/topologymap/components/perfoper/config/components/virtual/TopologymapVmConfigTable';
import WTopologymapStorageClusterConfigTable from '@/views/topologymap/components/perfoper/config/components/virtual/TopologymapStorageClusterConfigTable';
import WTopologymapStorageConfigTable from '@/views/topologymap/components/perfoper/config/components/virtual/TopologymapStorageConfigTable';

export default {
  name: 'WTopologymapConfigVirtualGroup',
  components: {
    WTopologymapHostClusterConfigTable,
    WTopologymapHostConfigTable,
    WTopologymapVmConfigTable,
    WTopologymapStorageClusterConfigTable,
    WTopologymapStorageConfigTable,
  },
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      activeTab: 'WTopologymapHostClusterConfigTable',
    };
  },
  computed: {
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/perfoper/config/components/TopologymapConfigVirtualGroup.vue